/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TAddFeedbackRequestModel,
  IAddFeedbackRequestRequest,
  IMappers,
  IAddFeedbackRequestResponseError,
  TAddFeedbackRequestResponse,
} from './types';

const defaultConfig: TAddFeedbackRequestModel = {
  apiType: 'public',
  assertStatusCodes: [204, 400],
  method: 'POST',
  microserviceName: 'moderation-complaints',
  pathApi: '/v1/add-feedback-request/',
  hostType: 'api',
} as TAddFeedbackRequestModel;

function createAddFeedbackRequestModel(parameters: IAddFeedbackRequestRequest): TAddFeedbackRequestModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IAddFeedbackRequestOptions<TResponse204, TResponse400> {
  httpApi: IHttpApi;
  parameters: IAddFeedbackRequestRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse204, TResponse400>;
}

async function fetchAddFeedbackRequest<TResponse204, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IAddFeedbackRequestOptions<TResponse204, TResponse400>): Promise<
  TResponse204 | TResponse400 | TAddFeedbackRequestResponse
> {
  const { response, statusCode } = await httpApi.fetch(createAddFeedbackRequestModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 204) {
      return mappers[204]();
    }

    if (statusCode === 400) {
      return mappers[400](response as IAddFeedbackRequestResponseError);
    }
  }

  return { response, statusCode } as TAddFeedbackRequestResponse;
}

export { defaultConfig, createAddFeedbackRequestModel, fetchAddFeedbackRequest };
